// extracted by mini-css-extract-plugin
export default {"button":"StyleSecondarySmallTrueD1_button__uP4CD","stylesecondarySmalltrueD":"StyleSecondarySmallTrueD1_stylesecondarySmalltrueD__N2rTC"};